import axios from '../utils/axios';

export default function fetchPotentialPaidJobs(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/potential-paid-jobs', {
            params: params
        })
    )
}
